var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLineup = function SvgLineup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#lineup_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.501 7.397c0-.983.177-2.977.306-4.295.076-.786.598-1.506 1.386-1.555.375-.025.752.008 1.117.098.603.151.918.742.941 1.363.046 1.227.113 3.572.113 6.825.227.127.64.326 1.09.551 1.25.627 1.685 1.946 1.216 3.264-.475 1.337-1 2.38-1.468 3.16-.756 1.26-2.111 1.95-3.577 2.068a40 40 0 0 1-5.535.051c-1.78-.112-3.297-1.189-3.72-2.922-.362-1.487-.69-3.675-.691-6.725 0-2.328.077-4.158.139-5.26.04-.726.477-1.382 1.191-1.514a4.5 4.5 0 0 1 1.024-.075c.746.033 1.245.698 1.33 1.44.103.919.24 2.314.332 3.997 2.864-.513 4.806-.47 4.806-.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.152 13.583a29 29 0 0 1-2.502-.104c-.742-.064-1.414-.502-1.628-1.216a6 6 0 0 1-.113-.44c-.177-.806.35-1.553 1.161-1.709 1.4-.269 3.089-.31 4.317-.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.137 13.583s-3.958-.416-3.958 2.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lineup_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.179.25h20v20h-20z"
  })))));
};
export default SvgLineup;